import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'replaceUnderscores',
})
export class ReplaceUnderscoresPipe implements PipeTransform {
	transform(text: string): string {
		if (text != null && text === '_') {
			return text.replace('_', '');
		} else if (text != null && text !== '_') {
			return text;
		}
		return text;
	}
}
